import type { Theme } from './types';

export const minimalTheme: Theme = {
  id: 'minimal',
  name: 'Minimal',
  description: 'Czysty, minimalistyczny design',
  preview: {
    primary: '#ffffff',
    secondary: '#f8fafc',
    accent: '#18181b',
  },
  colors: {
    bgPrimary: '#ffffff',
    bgSecondary: '#fafafa',
    bgTertiary: '#f4f4f5',
    bgAccent: '#e4e4e7',

    sidebarBg: '#fafafa',
    sidebarText: '#71717a',
    sidebarHover: '#f4f4f5',
    sidebarActive: '#18181b',

    headerBg: '#ffffff',
    headerGradient: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
    headerText: '#18181b',

    textPrimary: '#18181b',
    textSecondary: '#52525b',
    textMuted: '#a1a1aa',
    textInverse: '#ffffff',

    borderPrimary: '#e4e4e7',
    borderSecondary: '#d4d4d8',
    borderAccent: '#18181b',

    accentPrimary: '#18181b',
    accentHover: '#27272a',
    accentLight: '#f4f4f5',

    success: '#22c55e',
    successLight: '#dcfce7',
    warning: '#eab308',
    warningLight: '#fef9c3',
    error: '#ef4444',
    errorLight: '#fee2e2',
    info: '#6366f1',
    infoLight: '#e0e7ff',

    shadow: '0 1px 2px rgba(0,0,0,0.05)',
    shadowLg: '0 4px 6px -1px rgba(0,0,0,0.07)',
    overlay: 'rgba(0, 0, 0, 0.4)',

    scrollbarTrack: '#f4f4f5',
    scrollbarThumb: '#d4d4d8',
    scrollbarThumbHover: '#a1a1aa',

    inputBg: '#ffffff',
    inputText: '#18181b',
  },
  effects: {
    softShadows: true,
  },
};
